import { Component, Input, OnInit, Output, EventEmitter, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import { ErrorService } from 'src/app/services/Dossier/error.service';
import { Observable, Subscription } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { formatDate } from '@angular/common';
import { Document } from 'src/app/classes/dossier/document';
import { MatDialog } from '@angular/material';
import { ShowFileDialog } from 'src/app/views/dialogs-show-file/show-file-dialog.component';
import { DocumentService } from 'src/app/services/Dossier/document.service';

@Component({
    selector: 'app-single-contract',
    templateUrl: './single-contract.component.html',
    styleUrls: ['./single-contract.component.scss']
})
export class SingleContractComponent implements OnInit {
    
    @Input() dossierId: string;
    @Input() document: Document;
    @Input() types = [];
    @Input() assignedTypes;
    @Input() forceFormCheck: boolean;
    @Input() isEditable: boolean = true;
    
    @Output() selectedTypeEvent = new EventEmitter<any>();
    @Output() isValidEvent = new EventEmitter<any>();
    @Output() removeEvent = new EventEmitter<any>();

    form: FormGroup
    isValid: boolean;
    type = {
        label: "",
        value: "",
        date: "",
        date_value: "",
        selected: false,
        multiple: true,
    };

    currentChip;
    currentTypes = [];
    dateLabel: string = "Date";
    typeDocument: string = "Autre";
    chipError = "";

    constructor(
        private formBuilder: FormBuilder,
        private cdf: ChangeDetectorRef,
        private appService: AppService,
        private httpClient: HttpClient,
        private dialog: MatDialog,
        private documentService: DocumentService,
    ){
        this.form = this.formBuilder.group({
            name: [{value: "", disabled: true}, Validators.required],
            type: ["", Validators.required],
            date: ["", Validators.required],
        });
    }

    ngOnInit(): void {
        if (this.isEditable) {
            this.isValidDocument();
            this.form.get("name").setValue(this.document.name);
            if (this.document.date)
                this.form.get("date").setValue(formatDate(this.document.date, "yyyy-MM-dd", "en"));
        } else {
            if (this.document.type) {
                this.isValid = true;
                this.types.map( (type) => {
                    if (this.document.type === type.value) {
                        this.dateLabel = type.date;
                        this.typeDocument = type.label;
                    }
                })
            }
        }
    }

    ngOnChanges(changes) {
        if (this.forceFormCheck && this.isEditable)
            this.checkForm(true);
        if (changes.types && this.isEditable)
            this.loadTypes();
    }

    ngDoCheck() {
        if (this.isEditable)
            this.checkForm(false);
    }

    toggleChip(chip) {
        if (chip !== this.currentChip) {
            this.resetCurrentChips();
            if (!this.isChipTaken(chip) || chip.multiple) {
                this.selectedTypeEvent.emit({name: this.document.path, value: chip.value});
                this.highlightChip(chip);
                this.chipError = "";
            } else {
                this.selectedTypeEvent.emit({name: this.document.path, value: ""});
                this.currentChip = "";
                this.chipError = "Ce type est déjà assigné";
            }
        }
    }

    isChipTaken(chip) {
        let isTypeTaken = false;
        this.assignedTypes.map( (type) => {
            if (chip.value === type.value) {
                isTypeTaken = true;
            }
        })
        return isTypeTaken;
    }

    resetCurrentChips() {
        this.currentTypes.forEach(type => {
            type.selected = false;
        });
        this.form.get("type").setValue("");
        this.document.type = null;
    }

    highlightChip(chip) {
        chip.selected = true;
        this.currentChip = chip;
        this.form.controls["date"].enable();
        if (chip.date_value) {
            this.form.get("date").setValue(chip.date_value);
            this.document["date"] = chip.date_value;
            this.form.controls["date"].disable();
        }
        this.dateLabel = chip.date;
        this.document.type = chip.value;
        this.form.get("type").setValue(chip.value);
    }

    changeInput(input) {
        this.document[input] = this.form.get(input).value;
    }

    loadTypes() {
        this.currentTypes = []
        this.createTypes();
        this.initializeType();
        this.cdf.detectChanges();
    }

    createTypes() {
        this.types.map((type) => {
            this.createType(type);
        })
    }

    createType(model) {
        let newType = Object.create(this.type);
        newType.label = model.label;
        newType.value = model.value;
        newType.date = model.date;
        newType.multiple = model.multiple;
        newType.date_value = model.date_value;

        this.currentTypes.push(newType);
    }

    initializeType() {
        this.currentTypes.map((type) => {
            if (type.value === this.document.type) 
                this.toggleChip(type);
        });
    }

    checkForm(markAsTouched) {
        if (this.form.valid) {
            this.isValid = true;
        } else {
            this.isValid = false;
            if (markAsTouched)
                this.form.markAllAsTouched();
        }
        this.document.isValid = this.isValid;
        this.isValidEvent.emit(true);
    }

    isValidDocument() {
        if (this.document.isValid) {
            this.isValid = true;
        } else {
            this.isValid = false;
        }
    }

    show() {
        let pdfExt : RegExp = /\.pdf$/;
        let data = {
            url: this.document.path,
            name: this.document.name,
            page: 1,
            pdf: pdfExt.test(this.document.name) ? true : false,
        };

        if (data.pdf) {
            this.dialog.open(ShowFileDialog, {
                width: '100%',
                panelClass:'viewpdf-dialog',
                data: data,
            });
        } else {
            this.appService.downloadDocument(this.document.path, this.document.name).subscribe( res => {
                let link = document.createElement('a')
                link.download = this.document.name
                link.href = URL.createObjectURL(res)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            })
        }
    }

    download() {
        this.appService.downloadDocument(this.document.path, this.document.name).subscribe( res => {
            let link = document.createElement('a')
            link.download = this.document.name
            link.href = URL.createObjectURL(res)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        })
    }

    remove() {
        this.documentService.removeDocumentFromDossier(this.dossierId, this.document.id)
        .subscribe( (res) => {
            if (res.result && res.result.success) {
                this.removeEvent.emit(this.document.id);
            }
        })
    }
}